const useHomeDesign = async(slug: string): Promise<object> => {
    const {data: homeDesign} = await useAsyncData(slug, () => {
        return queryCollection("homeDesigns").where("slug", "=", slug).first();
    });

    return homeDesign?.value?.body || {};
}

const useHomeDesignUri = async(uri: string): Promise<object> => {
    const {data: page} = await useAsyncData(uri, async () => {
      
      let page = await queryCollection("homeDesigns").where("uri", "=", uri).first();
      
      if (!page) {
        const alternatePath = uri.endsWith('/') 
          ? uri.slice(0, -1) 
          : uri + '/';
  
        page = await queryCollection("homeDesigns").where("uri", "=", alternatePath).first();
      }
  
      return page;
    });
  
    return page?.value?.body || {};
}

const useAllHomeDesigns = async(): Promise<object> => {
    const { data } = await useAsyncData('all-home-designs', async () => {
        const homeDesigns = await queryCollection("homeDesigns").all()
        
        // Sort by date descending
        return homeDesigns.sort((a: any, b: any) => {
            return new Date(b.date).getTime() - new Date(a.date).getTime()
        })
    });

    return data;
}

export {
    useHomeDesign,
    useHomeDesignUri,
    useAllHomeDesigns
};